export const checkIsSelectBox = (masterBook) => {
  if (masterBook.length == 0) return false;

  var isSelectBox = false;
  if (
    masterBook._max_purchase_count[0].limited_type == "master_book" &&
    masterBook._max_purchase_count[0].gettable_counts[0].count > 1
  ) {
    isSelectBox = true;
  }
  if (masterBook.max_purchase_count > 1) {
    isSelectBox = true;
  }
  return isSelectBox;
};
